import './Loader.css';

export default function Loader({ done }) {
  return (
    <div className={`loader${done ? ' done' : ''}`}>
      <div className="loader-logo">FITNESS<span>KING</span></div>
      <div className="loader-bar">
        <div className="loader-fill" />
      </div>
    </div>
  );
}
